import React from "react";
import { Data } from "./ReportData";

export const RepairReport = (data: Data) => {
  const printWindow = window.open("", "_blank", "width=900,height=650");

  if (!printWindow) return;

  printWindow.document.open();
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Repair Completion Report</title>

      <style>
        @page {
          size: Letter;
          margin: 0.5in;
        }

        body {
          font-family: Arial, sans-serif;
          font-size: 11px;
          margin: 0;
        }

        .header {
          display: flex;
          align-items: center;
          border-bottom: 2px solid #000;
          padding-bottom: 10px;
          margin-bottom: 10px;
        }

        .logo {
        height: 100px;
        width: 150px;
        margin-right: 8px;
        }

        .company-name {
          font-size: 18px;
          font-weight: bold;
        }

        .title {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          border: 1px solid #000;
          padding: 6px;
          margin-bottom: 10px;
          background: #5cb35c;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        td {
          border: 1px solid #000;
          padding: 5px;
          vertical-align: top;
        }

        .label {
          font-weight: bold;
          width: 25%;
          background: #f3f3f3;
        }

        .section-title {
          text-align: center;
          font-weight: bold;
          //background: #e9e9e9;
          background: #5cb35c;
        }

        .box {
          height: 60px;
          vertical-align: top;
        }

        .box-large {
          height: 80px;
        }

        .signature {
          height: 70px;
          text-align: center;
        }

        .print-button {
          text-align: right;
          margin-bottom: 10px;
        }

        .print-button a {
          display: inline-block;
          padding: 6px 12px;
          background: #007bff;
          color: white;
          text-decoration: none;
          border-radius: 4px;
          font-size: 12px;
        }

        .print-button a:hover {
          background: #0056b3;
        }

        @media print {
          .print-button {
            display: none;
          }
        }        

      </style>
    </head>

    <body>

      <div class="print-button">
        <a href="#" onclick="window.print(); return false;">
          🖨 Print Report
        </a>
      </div>    

      <div class="header">
        <img class="logo" src="${data.logoPath}" />
        <div>
          <div>${data.divisionAddress}</div>
          <div>${data.divisionTelno}</div>
        </div>
      </div>

      <div class="title">
        REPAIR COMPLETION REPORT
      </div>

      <table>
        <tr>
          <td class="label">Work Order No</td>
          <td>${data.workOrderNo}</td>

          <td class="label">Date Received</td>
          <td>${data.dateReceived}</td>
        </tr>

        <tr>
          <td class="label">Assigned To</td>
          <td>${data.serviceTech}</td>

          <td class="label">Completion Date</td>
          <td>${data.completionDate}</td>
        </tr>

        <tr>
          <td class="section-title" colspan="4">CUSTOMER INFORMATION</td>
        </tr>

        <tr>
          <td class="label">Name</td>
          <td colspan="3">${data.customerName}</td>
        </tr>

        <tr>
          <td class="label">Company</td>
          <td colspan="3">${data.companyName ?? ""}</td>
        </tr>

        <tr>
          <td class="label">Contact No</td>
          <td colspan="3">${data.contactNo ?? ""}</td>
        </tr>

        <tr>
          <td class="section-title" colspan="4">EQUIPMENT INFORMATION</td>
        </tr>

        <tr>
          <td class="label">Type</td>
          <td>${data.equipmentType ?? ""}</td>

          <td class="label">Model</td>
          <td>${data.model ?? ""}</td>
        </tr>

        <tr>
          <td class="label">Serial</td>
          <td>${data.serialNumber ?? ""}</td>

          <td class="label">Meter Count</td>
          <td>${data.totalMeterCount ?? ""}</td>
        </tr>

        <tr>
            <td class="label">Accessories</td>
            <td
                colspan="3"
                style={{
                height: "60px",
                verticalAlign: "top",
                whiteSpace: "pre-wrap"
                }}
            >${data.accessories ?? ""}
            </td>
        </tr>
        <tr>
          <td class="section-title" colspan="4">Customer Reported Issue</td>
        </tr>

        <tr>
          <td colspan="4" class="box">${data.complaint ?? ""}</td>
        </tr>

        <tr>
          <td class="section-title" colspan="4">Technical Diagnosis</td>
        </tr>

        <tr>
          <td colspan="4" class="box">${data.technicalDiagnosis ?? ""}</td>
        </tr>
        
        <tr>
          <td class="section-title" colspan="4">Parts Replaced</td>
        </tr>

        <tr>
          <td colspan="4" class="box">${data.partsReplaced ?? ""}</td>
        </tr>

        <tr>
          <td class="section-title" colspan="4">Corrective Action Taken</td>
        </tr>

        <tr>
          <td colspan="4" class="box">${data.correctiveActionTaken ?? ""}</td>
        </tr>

        <tr>
          <td class="section-title" colspan="4">TERMS AND CONDITIONS</td>
        </tr>

        <tr>
            <td colspan="4" class="box">
                <div
                style={{
                    marginBottom: "6px",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}
                >
                We guarantee all parts sold and installed by us against defects in materials and workmanship for a period of thirty (30) days from the date of service. Any original issue reported and recurring within the 30-day warranty period will be covered under this guarantee. However, new or unrelated issues will be considered as separate chargeable service calls. Intermittent or inconsistent issues cannot be guaranteed due to their unpredictable nature and will be subject to further diagnosis and evaluation. Completed repairs that have been duly notified to the customer but remain unclaimed for thirty (30) days may be disposed of or subjected to storage or service charges without further notice.
                </div>
            </td>
        </tr>

        <tr>
          <td class="signature" colspan="2"><br/>
            Prepared By<br/><br/>
            _______________________<br/>
            Service Technician
          </td>

          <td class="signature" colspan="2"><br/>
            Accepted By<br/><br/>
            _______________________<br/>
            Equipment Owner / Representative
          </td>
        </tr>

      </table>

    </body>
    </html>
  `);

  printWindow.document.close();

  // printWindow.onload = () => {
  //   printWindow.focus();
  //   printWindow.print();
  // };
};
